import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../providers/auth_provider';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { formatDate } from '../../../utils/format_date';

export default function UploadedFiles({ user_id }) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchUploadedFiles = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/business-data/user/${user_id}`, {
          headers: {
            'Content-Type': 'application/json',
            Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          setUploadedFiles(response.data.business_data || []);
        } else {
          setError('Failed to fetch files.');
        }
      } catch (error) {
        setError('An error occurred while fetching files.');
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchUploadedFiles();
  }, [user_id, token]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div className='text-center text-danger'>{error}</div>;
  }

  return (
    <div className="card">
      <div className="table-responsive mb-4">
        <table className="table datatable-invoice">
          <thead>
            <tr>
              <th>#</th>
              <th>File</th>
              <th>Uploaded On</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {uploadedFiles.length > 0 ? (
              uploadedFiles.map((file, index) => (
                <tr key={file.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="badge bg-lighter rounded-3 mb-1_5">
                      <img
                        src="/assets/img/icons/misc/xls.png"
                        alt="file-icon"
                        width={15}
                        className="me-2"
                      />
                      <span className="h6 mb-0 text-secondary">
                        {file.file_name}
                      </span>
                    </div>
                  </td>
                  <td>
                    {formatDate(file.created_at)}
                  </td>
                  <td>
                    <Link download={true} target='_blank' to={file.file_url}>
                      <i className='tf-icon ri-file-download-line ri-20px'></i>
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className='text-center'>No Files Uploaded</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
